import script from "./MapHotspots.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapHotspots.vue?vue&type=script&lang=ts&setup=true"

import "./MapHotspots.vue?vue&type=style&index=0&id=a3fe9722&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3fe9722"]])

export default __exports__